// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"81568cc3","742":"b9b0b314","787":"77f4ecf5"}[chunkId] + ".chunk.js";
};